<section class="referral-program-hero">
  <img
    [src]="REFERRAL_ENVELOPE_IMAGE"
    alt=""
    width="200"
    height="200"
    class="referral-program-hero__art referral-program-hero__art--mobile d-md-none"
  />

  <div class="referral-program-hero__content">
    <h1 class="referral-program-hero__title semi-bold">
      Invite friends. Earn up to {{ program.rewardAmount | portalCurrency: true }} each
    </h1>
    <p class="referral-program-hero__subtitle mt-2">
      They get {{ program.rewardAmount | portalCurrency: true }} in travel credit. You earn up to
      {{ program.rewardAmount | portalCurrency: true }} after they complete their journey.
      <span class="referral-program-hero__terms d-none d-md-inline">T&amp;C apply</span>
    </p>

    @if (shareUrl) {
      <div class="referral-program-hero__desktop-actions d-none d-md-block">
        <div class="referral-program-hero__link-row">
          <p class="referral-program-hero__link text-break" data-id="referral-shareable-url">
            {{ shareUrl }}
          </p>
          <button
            type="button"
            class="referral-program-hero__copy"
            [copyToClipboard]="shareUrl"
            (click)="onLinkCopied()"
            data-id="referral-copy-link"
            [attr.aria-label]="linkCopied ? 'Copied' : 'Copy referral link'"
          >
            <img src="assets/icons/document_on_document.svg" alt="" width="20" height="20" />
          </button>
        </div>

        <div class="referral-program-hero__share mt-4">
          <a
            [href]="shareLinks.mail"
            class="referral-program-hero__share-btn"
            (click)="trackShare('email')"
            data-id="referral-share-email"
          >
            <img [src]="REFERRAL_SHARE_EMAIL_ICON" alt="" width="20" height="20" />
            Email
          </a>
          <a
            [href]="shareLinks.sms"
            class="referral-program-hero__share-btn"
            (click)="trackShare('sms')"
            data-id="referral-share-messages"
          >
            <img [src]="REFERRAL_SHARE_MESSAGES_ICON" alt="" width="20" height="20" />
            Messages
          </a>
          <a
            [href]="shareLinks.whatsApp"
            target="_blank"
            rel="noopener noreferrer"
            class="referral-program-hero__share-btn"
            (click)="trackShare('whatsapp')"
            data-id="referral-share-whatsapp"
          >
            <img [src]="REFERRAL_SHARE_WHATSAPP_ICON" alt="" width="20" height="20" />
            WhatsApp
          </a>
          <a
            [href]="shareLinks.messenger"
            target="_blank"
            rel="noopener noreferrer"
            class="referral-program-hero__share-btn"
            (click)="trackShare('messenger')"
            data-id="referral-share-messenger"
          >
            <img [src]="REFERRAL_MESSENGER_ICON" alt="" width="20" height="20" />
            Messenger
          </a>
        </div>
      </div>

      <div class="referral-program-hero__mobile-actions d-md-none">
        <ds-button
          label="Share link"
          [fullWidth]="true"
          (click)="shareReferralLink()"
          data-id="referral-share-link-mobile"
        />
        <ds-button
          variant="secondary"
          [label]="linkCopied ? 'Copied' : 'Copy link'"
          [fullWidth]="true"
          (click)="copyReferralLink()"
          data-id="referral-copy-link-mobile"
        />
      </div>
    }
  </div>

  <img
    [src]="REFERRAL_ENVELOPE_IMAGE"
    alt=""
    width="200"
    height="200"
    class="referral-program-hero__art d-none d-md-block"
  />
</section>
